/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisconfigurationTrendResponse {
    getFixupPrototypeFunction() { return InfraMisconfigurationTrendResponse.fixupPrototype; }

    static newInstance(model: Partial<InfraMisconfigurationTrendResponse>): InfraMisconfigurationTrendResponse {
        let obj = Object.assign(new InfraMisconfigurationTrendResponse(), model);
        InfraMisconfigurationTrendResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisconfigurationTrendResponse>): InfraMisconfigurationTrendResponse {
        if (!model) return null;
        return InfraMisconfigurationTrendResponse.newInstance(<InfraMisconfigurationTrendResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisconfigurationTrendResponse) {
        if (!obj) return;

        models.InfraMisconfigurationTrendResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisconfigurationTrendResponse): boolean {
        Object.setPrototypeOf(obj, InfraMisconfigurationTrendResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.items) {
            for (let val of this.items) {
                models.InfraMisConfiguration.fixupPrototype(val);
            }
        }
    }

    /**
     * List of infra misconfiguration trend recommendation items
     */
    items: Array<models.InfraMisConfiguration>;

    /**
     * Pagination context for the next batch
     */
    next_list_context: models.ListContext;

}
